import { useState } from "react";
import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";

import LoginForm from "components/auth/LoginForm";
import RegisterForm from "components/auth/RegisterForm";

import Image from "assets/images/login.png";
import Wave from "assets/images/wave.png";

export default function Login() {
  const [login, setLogin] = useState(true);
  const [imgMoveRight, setImgMoveRight] = useState(false);
  const [imgMoveLeft, setImgMoveLeft] = useState(false);
  const [contentMoveRight, setContentMoveRight] = useState(false);
  const [contentMoveLeft, setContentMoveLeft] = useState(false);
  const [initMove, setInitMove] = useState(false);

  const { isAuthenticated } = useSelector((state) => state.authReducer);

  const handleMove = () => {
    setLogin(!login);
    setImgMoveRight(!imgMoveRight);
    setContentMoveLeft(!contentMoveLeft);
    setInitMove(true);
    if (initMove) {
      setImgMoveLeft(!imgMoveLeft);
      setContentMoveRight(!contentMoveRight);
    }
  };

  return (
    <>
      {isAuthenticated ? (
        <Navigate to="/" />
      ) : (
        <section className="section-auth">
          <div className="container-fluid">
            <div className="row">
              <div
                className={`col-5 panel ${imgMoveRight ? "move-right" : ""} ${
                  imgMoveLeft ? "move-left" : ""
                }`}
                id="img-panel"
              >
                <div className="wrapper">
                  <h2 className="my-4">
                    Start your <br /> journey now!
                  </h2>
                  <img
                    className="img-login my-auto"
                    src={Image}
                    alt="imagelogin"
                  />
                  <div className="wave-shape ">
                    <img src={Wave} alt="" />
                  </div>
                </div>
              </div>
              <div
                className={`col-7 panel-content ${
                  contentMoveLeft ? "move-left" : ""
                } ${contentMoveRight ? "move-right" : ""}`}
              >
                {login ? (
                  <LoginForm handleMove={handleMove} initMove={initMove} />
                ) : (
                  <RegisterForm handleMove={handleMove} />
                )}
              </div>
            </div>
          </div>
        </section>
      )}
    </>
  );
}
